module.exports = __webpack_public_path__ + "img/contents_market_mob_main_02.d46fe28.png";